import React from "react";
import { WhenBuilder } from "../WhenBuilder";
import type { RuleComponentProps } from "./types";

export const RuleNot: React.FC<RuleComponentProps> = ({
    value,
    onChange,
    depth,
    evaluationDomain,
    declaredDerivedAttributeNames = [],
}) => (
    <WhenBuilder
        value={value?.not?.condition}
        onChange={(condition) => {
        if (condition) onChange({ not: { condition } });
    }}
        depth={depth + 1}
        evaluationDomain={evaluationDomain}
        declaredDerivedAttributeNames={declaredDerivedAttributeNames}
    />
);
